var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.67214 6.35143L14.0968 0H12.8111L8.10214 5.51464L4.33929 0H0L5.68929 8.34L0 15H1.28571L6.25929 9.17571L10.2332 15H14.5725L8.67214 6.35143ZM6.91179 8.41286L6.33536 7.5825L1.74857 0.975H3.72321L7.42393 6.3075L8.00036 7.13786L12.8121 14.07H10.8375L6.91179 8.41286Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.0dcb2691204380e40d2c3f863ef7a93a.svg";
export { ForwardRef as ReactComponent };